<template>
    <div class="container-fluid">
        <preloader v-if="isLoading"/>
        <bracket class="tournament-bracket" :rounds="rounds" v-if="!isLoading">
            <template #player="{ player }">
                {{ player.name }}
            </template>

        </bracket>
    </div>
</template>

<script>
    import Bracket from "vue-tournament-bracket";
    import BaseService from "../_framework/api/BaseService";
    import Utils from "../_framework/utils/Utils";

    const rounds = [
        //Semi finals
        {
            games: [
                {
                    player1: { id: "1", name: "Competitor 1", winner: true },
                    player2: { id: null, name: '-', winner: null }
                },
                {
                    player1: { id: "3", name: "Competitor 3", winner: false },
                    player2: { id: "4", name: "Competitor 4", winner: true }
                },
                {
                    player1: { id: "5", name: "Competitor 5", winner: true },
                    player2: { id: "6", name: "Competitor 6", winner: false }
                },
                {
                    player1: { id: "7", name: "Competitor 7", winner: null },
                    player2: { id: "8", name: "Competitor 8", winner: null }
                }
            ]
        },
        {
            games: [
                {
                    player1: { id: "1", name: "Competitor 1", winner: true },
                    player2: { id: "4", name: "Competitor 4", winner: false }
                },
                {
                    player1: { id: "5", name: "Competitor 5", winner: null },
                    player2: { id: null, name: "-", winner: null }
                }
            ]
        },
        {
            games: [
                {
                    player1: { id: "1", name: "Competitor 1", winner: null },
                    player2: { id: null, name: "-", winner: null }
                }
            ]
        }
    ];

    export default {
        name: "tournamentBracket",
        components: {
            Bracket
        },
        props: {
            id: Number,
        },
        data() {
            return {
                rounds: rounds,
                pretableId: 0,
                queryParams: {
                    pretableId: 0
                },
                isLoading: false
            }
        },
        mounted() {
            // console.log(this.id);
            this.pretableId = this.id;
            this.queryParams.pretableId = this.pretableId;
            this.getTournamentBracketData(this.pretableId);
        },
        methods: {
            getTournamentBracketData(id) {
                this.isLoading = true;
                new BaseService("MatchTable", '/GetMatchTableDiagram').getList(this.queryParams).then(response => {
                    this.isLoading = false;
                  // console.log(response.data);
                  this.rounds = response.data.rounds;
                  //   console.log(this.rounds)
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                })

            }
        }
    }
</script>

<style>
    .vtb-wrapper {
        display: flex;
        justify-content: center;
        width: 100%;
        /*height: 100vh;*/
        direction: ltr;
    }
    .vtb-item-players .winner {
        background-color: #2a5298;
        transition: all 0.3s;
    }
    .vtb-item-players .winner.highlight {
        background-color: #0575e6;
    }
    .vtb-item-players .defeated{
        background-color: #97172e;
        transition: all 0.3s;
    }
    .vtb-item-players .defeated.highlight{
        background-color: #c3073f;
    }
    .vtb-item-players:empty:before  {
        content: ' ';
        display: none !important;
    }
    @media (min-width: 1200px) {
        .vtb-item-players .vtb-player {
            min-width: 160px;
            text-align: left;
        }
    }
</style>







